<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        config-module="92111"
        :expand-adv="true"
        :show-simple="false"
        :custom-search-items="customSearchItems"
        @advSearchItemCallBack="queryHandler"
      >
        <div slot="operations">
          <el-button v-if="batchGenerateCarFormShow && source === 'useCarApplicationFormTab'" type="primary" @click="$emit('batchGenerateCarFormHandle')">{{ $t('CargoMsg.Cargo_BatchGenerateVehicleOrder') }}</el-button>
        </div>
      </search-item>
      <div style="flex: 1 1 0;min-height: 350px;">
        <cargo-ag-grid-wrapper
          config-module="202506072"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-selected-color="false"
          :check-sub-record="false"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202506072"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import CargoAgGridAssemblyEditor from '@/components/Cargo/Common/CargoAgGridAssemblyEditor/index'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import { queryUseCarApplicationForm } from '@/api/booking/carForm'
import CarFormTabDetail from '@/components/Cargo/CarForm/carFormTabDetail'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'

export default {
  name: 'UseCarApplicationFormTabList',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, CarFormTabDetail },
  props: {
    lob: { type: String, default: '' },
    source: { type: String, default: '' },
    excludeUseCarApplicationFormUuids: { type: Array, default: () => [] }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAssemblyEditor,
          CargoAgGridColumnEditGroup
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VehicleRequestFormNo'),
          field: 'truckOrderNo',
          colId: 'truckOrderNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PickUpDelivery'),
          field: 'pickUpDelivery',
          colId: 'pickUpDelivery',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.USE_CAR_APPLICATION_FORM_SOURCES)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Motorcade'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          colId: 'remarks',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Customer'),
          field: 'customerId',
          colId: 'customerId',
          width: 180,
          cellRenderer: (params) => {
            return params.value ? CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          }
        }, {
          headerName: this.$t('SeaExport.Door'),
          field: 'doorName',
          colId: 'doorName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          width: 200
        }, {
          headerName: this.$t('SeaExport.DoorContactPerson'),
          field: 'doorMan',
          colId: 'doorMan',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DoorContactNumber'),
          field: 'doorManTel',
          colId: 'doorManTel',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EstimatedPickUpDate'),
          field: 'estimatedPickUpDate',
          colId: 'estimatedPickUpDate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Port2'),
          field: 'port',
          colId: 'port',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.data.port, params.data.lob)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.data.port, params.data.lob)
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      gridApi: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      customSearchItems: []
    }
  },
  computed: {
    // 批量生成车单 权限
    batchGenerateCarFormShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_UseCarApplicationFormTabAE_BatchGenerateCarForm'])
          break
        default:
      }
      return show
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        this.queryHandler()
      }
    }
  },
  created() {
    // 初始化 自定义 高级查询
    this.customSearchItems = this.getCustomSearchItems()
    this.$nextTick(async() => {
      // 等待高级查询组装完毕
      await this.$refs.searchItem.fetchInitData()
      this.$refs.searchItem.advSearch()
    })
  },
  methods: {
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 业务日期
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'job.DATE_CREATED'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessCreationTime'
      searchField.itemValue = []
      searchField.subType = 'range'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.lock = false
      // 设置默认日期范围
      const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD') // 当前时间的前一个月时间
      searchField.defaultValue = [startDate]
      searchField.action = AdvancedSearchField.ADD_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    // batchGenerateCarFormHandle() {
    //   if (!this.selectedRows || this.selectedRows.length === 0) {
    //     this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
    //     return
    //   }
    //   this.view = 'detail'
    //   this.$nextTick(() => {
    //     this.$refs.carFormTabDetail.form = { status: SystemConstants.CAR_FORM_STATUS_NOT_SENT.code, useCarApplicationFormVos: this.selectedRows }
    //     this.$refs.carFormTabDetail.isEdit = true
    //   })
    // },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.excludeUseCarApplicationFormUuids = this.excludeUseCarApplicationFormUuids
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryUseCarApplicationForm(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRows = []
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .input-label {
    display: inline-block;
    width: 60px;
    color: #666666;
  }
  .el-form{
    /deep/ .el-input__inner{
      width: 300px;
    }
  }
</style>
